/**
 * The global state selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = state => {
  const storedData = JSON.parse(localStorage.getItem('globalState')); // Get stored data from local storage
  return storedData || state.global || initialState; // Use stored data if available, or fallback to state or initial state
}

const selectRouter = state => state.router;

const makeSelectCurrentUser = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.currentUser,
  );

const makeSelectLoading = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.error,
  );

const makeSelectRepos = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.userData.repositories,
  );

const makeSelectLocation = () =>
  createSelector(
    selectRouter,
    routerState => routerState.location,
  );

  const selectUserName = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.userName,
  );

  const getEmployeeRole = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.role_type,
  );

  const getVendorEmployeeID = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.vendor_emp_id,
  );

export {
  selectGlobal,
  makeSelectCurrentUser,
  makeSelectLoading,
  makeSelectError,
  makeSelectRepos,
  makeSelectLocation,
  selectUserName,
  getEmployeeRole,
  getVendorEmployeeID
};
